import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=48b13a66&scoped=true&"
import script from "./AppIcon.vue?vue&type=script&lang=js&"
export * from "./AppIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b13a66",
  null
  
)

export default component.exports